
<div class="pa-0">
    <c-drawer-header
        title  = "Termine"
        icon   = "fas fa-bell"
        filter = "true"
        @close = "onClose"
        @arrow = "onArrow"
    />

    <v-row class="mt-0">
        <v-col class="crm-reminder-col">
            <v-text-field hide-details append-icon="fas fa-search" class="pl-4 pr-5 pt-2 pb-1"/>
            <v-layout row wrap  class="crm-reminder-list" :style="'height: ' + height + 'px'">
                <div v-if="reminder.length === 0" class="crm-no-messages">
                    Keine Erinnerungen
                </div>
                <div v-if="reminder.length > 0" class="w-100">
                        <crm-reminder-entry
                            v-for="(reminder, index) in reminder" :key="index"
                            :reminder="reminder"
                            v-model="menuOpen"
                            class="mb-4"
                        />
                </div>
            </v-layout>
        </v-col>
    </v-row>
</div>
